module.exports = __webpack_public_path__ + "static/media/5.1d34f4d0.png";